module.exports = __webpack_public_path__ + "img/people-yellow.d487566d.svg";